// SmsBanking.jsx

import React from "react";
import "../styles/SmsBanking.css";
import { FaSms, FaBell, FaShieldAlt, FaMobileAlt } from "react-icons/fa";

const SmsBanking = () => {
    return (
        <div className="sms-page">

            {/* HERO */}
            <section className="sms-hero">
                <h1>SMS Banking</h1>
                <p>Bank Anytime. Anywhere. Without Internet.</p>
            </section>

            {/* INTRO SECTION */}
            <section className="sms-intro">
                <div className="sms-container sms-intro-wrapper">

                    <div className="sms-intro-text">
                        <h2>Banking Made Simple via SMS</h2>
                        <p>
                            No internet access? Extend your banking services beyond regular
                            hours with our SMS feature. Receive immediate, real-time
                            transaction notifications through SMS.
                        </p>

                        <p>
                            You can also stay informed about your account balance, account
                            statements, status of issued cheques, and more by sending SMS
                            requests from your registered mobile number.
                        </p>

                        <p>
                            This service is uncomplicated, secure, and hassle-free.
                            We've made banking easy.
                        </p>
                    </div>

                    <div className="sms-intro-image">
                        <img
                            src="https://images.unsplash.com/photo-1511707171634-5f897ff02aa9"
                            alt="SMS Banking"
                        />
                    </div>

                </div>
            </section>

            {/* ALERTS SECTION */}
            <section className="sms-alerts">
                <h2 className="section-title">Receive Alerts For</h2>

                <div className="sms-container alerts-grid">

                    <div className="alert-card">
                        <FaBell className="alert-icon" />
                        <p>Credit or Debit transactions </p>
                    </div>

                    <div className="alert-card">
                        <FaSms className="alert-icon" />
                        <p>Issued Cheques</p>
                    </div>

                    <div className="alert-card">
                        <FaMobileAlt className="alert-icon" />
                        <p>Deposited Cheques</p>
                    </div>

                    <div className="alert-card">
                        <FaShieldAlt className="alert-icon" />
                        <p>Term Deposit Maturity Reminders</p>
                    </div>

                </div>
            </section>

            {/* HOW IT WORKS */}
            <section className="sms-how">
                <h2 className="section-title">How SMS Banking Works</h2>

                <div className="sms-container how-grid">

                    <div className="how-card">
                        <span>1</span>
                        <h3>Register Mobile Number</h3>
                        <p>Ensure your mobile number is linked to your bank account.</p>
                    </div>

                    <div className="how-card">
                        <span>2</span>
                        <h3>Send SMS Request</h3>
                        <p>Send a predefined SMS command from your registered number.</p>
                    </div>

                    <div className="how-card">
                        <span>3</span>
                        <h3>Receive Instant Response</h3>
                        <p>Get account details or transaction alerts instantly via SMS.</p>
                    </div>

                </div>
            </section>

            {/* BENEFITS */}
            <section className="sms-benefits">
                <h2 className="section-title">Why Choose SMS Banking?</h2>

                <div className="sms-container benefits-grid">
                    <div>✔ No Internet Required</div>
                    <div>✔ 24/7 Access</div>
                    <div>✔ Secure & Encrypted Alerts</div>
                    <div>✔ Works on Any Mobile Phone</div>
                    <div>✔ Instant Notifications</div>

                </div>
            </section>

        </div>
    );
};

export default SmsBanking;